import { v$,listen,animate } from './helpers.js';
import $  from 'jquery';
//Elements 

let dropDowns = v$('.drop_down'),
    dropDownTitles  = $('.drop_down-title');


//Functions

const getHeight = target => {
    let height = 0;
    target.style.height = 'auto';
    height = target.getBoundingClientRect().height;
    target.style.height = 0;
    return height;
}


dropDownTitles.on('click',function(e){
        $(this).parent().children('.drop_down-content').slideToggle();
        $(this).parent().toggleClass('active');
})

